<template>
<div class="master">
    <select class="form-control hours"
        v-model="hours" 
        @change="onChange"
        :disabled="disabled">
        <option 
            v-for="num in hoursRange" 
            :key="num"
            :value="num">
            {{ num }}
        </option>
    </select>
    <select class="form-control minutes"
        v-model="minutes" 
        @change="onChange"
        :disabled="disabled">
        <option 
            v-for="num in minutesRange" 
            :key="num"
            :value="num">
            {{ num }}
        </option>
    </select>
</div>
</template>

<script>
export default {
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String,
            required: false,
            default: '00:00',
        },
        min: {
            type: String,
            required: false,
            default: '00:00',
        },
        max: {
            type: String,
            required: false,
            default: '24:00',
        },
        step: {
            type: Number,
            required: false,
            default: 10,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data: () => ({
        startHour: '00',
        endHour: '24',
        hours: '00',
        minutes: '00',
    }),
    computed: {
        hoursRange() {
            const hours = [];
            const start = -(-this.startHour);
            const end = -(-this.endHour);
            
            for (let i = start;i <= end;i++) {
                hours.push(i < 10 ? `0${ i }` : i+'')
            }

            return hours;
        },
        minutesRange() {
            const step = this.step;
            const minutes = [];

            for (let i = 0;i < 60;i += step) {
                minutes.push(i < 10 ? `0${ i }` : i+'')
            }

            return minutes;
        },
    },
    watch: {
        modelValue() {
            this.handleValue()
        },
    },
    methods: {
        init() {
            if (this.min) {
                const [ minHour ] = this.min.split(':')

                this.startHour = minHour
            }

            if (this.max) {
                const [ maxHour ] = this.max.split(':')
                
                this.endHour = maxHour < this.startHour ? '24' : maxHour
            }
            
            this.hours = this.startHour
            this.handleValue()
        },
        handleValue() {
            if (this.modelValue === null) return;

            const [ hours, minutes ] = this.modelValue.split(':')
            
            this.hours = hours
            this.minutes = minutes > 0 ? minutes : '00'
        },
        onChange() {
            const hours = this.hours
            const minutes = this.minutes
            
            this.$emit('update:modelValue', `${ hours }:${ minutes }`)
        },
    },
    mounted() {
        this.init()
    }
}
</script>

<style scoped>
.master {
    display: flex;
}

.hours {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.minutes {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
</style>